/**
 * Yellow dot + "Polling mode" text when the socket is disconnected
 * and the app has fallen back to HTTP polling.
 */

interface LatencyIndicatorProps {
  isPolling: boolean;
}

export function LatencyIndicator({ isPolling }: LatencyIndicatorProps) {
  if (!isPolling) return null;

  return (
    <div className="flex items-center gap-1.5 px-3 py-1.5 bg-yellow-50 border border-yellow-200 rounded-md text-xs text-yellow-700">
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-500" />
      </span>
      Polling mode
    </div>
  );
}
